export const APP_NAME = 'Barter';
export const MAX_PHOTOS_PER_AD = 5;
export const MAX_PHOTO_SIZE_MB = 5;
export const MAX_PHOTO_SIZE_BYTES = MAX_PHOTO_SIZE_MB * 1024 * 1024;
export const ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
export const ADS_PER_DAY_LIMIT = 50;
export const RATE_LIMIT_WINDOW_MS = 60_000;
export const RATE_LIMIT_MAX_REQUESTS = 100;
export const CURRENCIES = ['UAH', 'USD', 'EUR', 'MDL'];
export const AD_STATUSES = ['active', 'sold', 'archived'];
//# sourceMappingURL=constants.js.map